export const LOCALES = {
  RUSSIAN: "ru-RU",
  ENGLISH: "en-US",
  GERMAN: "de-DE",
};
